import { Space, Spin } from "antd";
import useWindowWidth from "../../hooks/useWindowWidth";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  LoginOutlined,
  MoneyCollectOutlined,
  SnippetsOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import httpclient from "../../service/httpclient";
import "./RecruitmentQuestionMembership.scss";

const RecruitmentQuestionMembership = () => {
  const { deviceType } = useWindowWidth();
  const history = useHistory();

  const [productMembership, setProductMembership] = useState(null);
  useEffect(() => {
    httpclient.getOneProductMembership(1).then((res) => {
      setProductMembership(res);
    }, []);
  }, []);

  const expiredAt =
    productMembership?.record?.expire_time &&
    new Date(productMembership?.record?.expire_time);
  const hasProductMembership = expiredAt && Date.now() < expiredAt?.getTime();
  const hasEarlyBirdDiscount = productMembership?.early_bird_discount > 0;

  return (
    <>
      <Space style={{ marginTop: 24 }} size="middle" wrap>
        <img
          src="https://cdn.datongbei.com/icdesign-logo.png"
          style={{ height: 60 }}
          alt="logo"
        />
        <span style={{ fontSize: 28, fontWeight: "bold", color: "#4970a2" }}>
          题库Pro会员
        </span>
      </Space>

      {productMembership ? (
        <div
          style={{
            width: deviceType === "mobile" ? "90%" : "max(60%, 500px)",
            maxWidth: 640,
          }}
          className="membership-info-container"
        >
          <div className="membership-info-header">
            <div className="membership-info-title">一年期会员</div>
            {hasProductMembership ? (
              <>
                <br />
                <div className="membership-info-promo-box">
                  <div className="membership-info-promo-text">
                    你已是会员！有效期至：
                    <span style={{ whiteSpace: "nowrap" }}>
                      {expiredAt.toLocaleString()}
                    </span>
                    <br />
                    可前往题库观看视频解答！
                  </div>
                </div>
                <div className="membership-info-btn-container">
                  <button
                    className="membership-info-btn"
                    onClick={() => history.push("/recruitment-question-set")}
                  >
                    前往题库
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="membership-info-price">
                  ¥{productMembership.calculated_price / 100}
                  {productMembership.calculated_price !==
                    productMembership.price && (
                    <span className="membership-info-original-price">
                      ¥{productMembership.price / 100}
                    </span>
                  )}
                </div>
                <div className="membership-info-daily-price">
                  平均
                  {Math.round(productMembership.calculated_price / 365) / 100}
                  元/天
                </div>
                <div className="membership-info-promo-box">
                  <div className="membership-info-promo-text">
                    优惠规则：
                    {hasEarlyBirdDiscount && (
                      <>
                        早鸟优惠
                        <b>{productMembership.early_bird_discount / 100}元</b>
                        {" + "}
                      </>
                    )}
                    用户已购题单抵扣
                    <b>{productMembership.total_list_cost / 100}元</b>
                    ，至多减至0.01元
                    {/*<br />*/}
                    {/*开通即送 <b>2张直播兑换券</b>，可兑换任意直播课或直播场次*/}
                  </div>
                </div>
                <div className="membership-info-btn-container">
                  <button
                    className="membership-info-btn"
                    onClick={() =>
                      history.push("/checkout/product_memberships/1")
                    }
                  >
                    开通会员
                  </button>
                </div>
              </>
            )}
          </div>
          <div
            style={{ padding: deviceType === "mobile" ? "0 14px" : "0 20px" }}
            className="membership-info-content"
          >
            <div className="membership-info-benefits-title">会员权益</div>
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <VideoCameraOutlined />
                  解锁题单
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  题库价值159+69+69+69=366元
                </div>
                <div className="membership-info-benefit-desc">
                  四个题单全部解锁
                </div>
              </div>
            </div>
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <SnippetsOutlined />
                  模拟考试
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  Pro会员专属模考福利
                </div>
              </div>
            </div>
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <LoginOutlined />
                  新题速递
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  秋招季200+新题更新
                </div>
                <div className="membership-info-benefit-desc">
                  100+新题视频解答！
                </div>
              </div>
            </div>
            {/*<div className="membership-info-benefit">*/}
            {/*  <div className="membership-info-benefit-title">*/}
            {/*    <Space>*/}
            {/*      <VideoCameraOutlined />*/}
            {/*      直播福利*/}
            {/*    </Space>*/}
            {/*  </div>*/}
            {/*  <div className="membership-info-benefit-info">*/}
            {/*    <div className="membership-info-benefit-desc">*/}
            {/*      开通会员即送2张直播兑换券*/}
            {/*    </div>*/}
            {/*    <div className="membership-info-benefit-desc">*/}
            {/*      可用于兑换任意直播课或直播场次*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <MoneyCollectOutlined />
                  专栏福利
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  专栏半价优惠券一张
                </div>
                <div className="membership-info-benefit-desc">
                  专栏50元代金券一张
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Spin style={{ marginTop: 64 }} />
      )}
    </>
  );
};

export default RecruitmentQuestionMembership;
